import { type PropsWithChildren } from "react";
import { Canvas } from "react-three-map";
import { useSnapshot } from "src/hooks/useSnapshot";
import { SnapshotService } from "src/services/useSnapshot.service/useSnapshot.service";
import { observer } from "mobx-react-lite";

type Props = PropsWithChildren<{
  origin: { lng: number; lat: number };
}>;

// Stable id so other Mapbox layers can target it via `beforeId` (e.g. the
// stencil overlay sits below this so opacity doesn't dim the design).
export const THREE_LAYER_ID = "tessa-three-design";

export const ThreeLayer = observer(function ThreeLayer(props: Props) {
  const snapshot = useSnapshot();
  return (
    <Canvas
      id={THREE_LAYER_ID}
      latitude={props.origin.lat}
      longitude={props.origin.lng}
      frameloop="demand"
    >
      <hemisphereLight args={[0xffffff, 0x60666c]} position={[1, 4.5, 3]} />
      <SnapshotService.Provider value={snapshot}>{props.children}</SnapshotService.Provider>
    </Canvas>
  );
});
